import jwtDecode from "jwt-decode";
import rootReducer from "../store/reducers";

const acTokenKey = "ac_token";
const rfTokenKey = "rf_token";

type StateType = ReturnType<typeof rootReducer>;
const AUTH_LS_KEY = "__INTERNAL__";

export const loadState = (): StateType | undefined => {
  try {
    const serializedState = localStorage.getItem("AUTH");
    if (serializedState === null) {
      return undefined;
    }
    const serializedJson = atob(serializedState);
    const json = JSON.parse(serializedJson);
    return {
      auth: {
        ...json.auth,
        revoked: false,
      },
      // user: {
      // 	...initialState,
      // },
    } as unknown as StateType;
  } catch (err) {
    return undefined;
  }
};
export const getAcToken = () => {
  return localStorage.getItem(acTokenKey);
};

export const setAcToken = (token: string) => {
  localStorage.setItem(acTokenKey, token);
};

export const removeAcToken = () => {
  localStorage.removeItem(acTokenKey);
};

export const getRfToken = () => {
  return localStorage.getItem(rfTokenKey);
};

export const setRfToken = (token: string) => {
  localStorage.setItem(rfTokenKey, token);
};

export const removeRfToken = () => {
  localStorage.removeItem(rfTokenKey);
};

export const decodeToken = (token: string) => {
  return jwtDecode(token);
};

export const getAuthUser = () => {
  const token = getAcToken();
  return token ? decodeToken(token) : null;
};
